/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormFieldError } from 'uikit/forms';

import FormFieldUploadPreview from './formFieldUploadPreview';
import FormFieldUploadActions from './formFieldUploadActions';

import styles from '../styles/formFieldUpload.module.scss';

const FormFieldUpload = ({
  altTextLabel = '',
  buttonSize = 'medium',
  className = '',
  fieldId,
  handleAltTextChange,
  handleFileUpload,
  handleRemoveUpload = null,
  hasAltTextInput = false,
  hasIcon = false,
  hasRemoveUploadButton = false,
  hasReplaceUploadButton,
  icon = '',
  iconPosition = 'right',
  isDisabled = false,
  permittedFormats = '',
  removeUploadButtonText = '',
  replaceUploadButtonText = '',
  upload,
  uploadButtonText,
  uploadType = 'document',
}) => (
  <div className={classNames(styles.element, className)}>
    <FormFieldUploadPreview
      key="forms__form-field-upload-preview"
      upload={upload}
      uploadType={uploadType}
    />
    <FormFieldUploadActions
      altTextLabel={altTextLabel}
      buttonSize={buttonSize}
      fieldId={fieldId}
      handleAltTextChange={handleAltTextChange}
      handleFileUpload={handleFileUpload}
      handleRemoveUpload={handleRemoveUpload}
      hasAltTextInput={hasAltTextInput}
      hasIcon={hasIcon}
      hasRemoveUploadButton={hasRemoveUploadButton}
      hasReplaceUploadButton={hasReplaceUploadButton}
      icon={icon}
      iconPosition={iconPosition}
      isDisabled={isDisabled}
      permittedFormats={permittedFormats}
      removeUploadButtonText={removeUploadButtonText}
      replaceUploadButtonText={replaceUploadButtonText}
      upload={upload}
      uploadButtonText={uploadButtonText}
    />
    <FormFieldError hasError={!!upload.error} isDirty isHidden={false} error={upload.error} />
  </div>
);

FormFieldUpload.propTypes = {
  altTextLabel: PropTypes.string,
  buttonSize: PropTypes.string,
  className: PropTypes.string,
  fieldId: PropTypes.string.isRequired,
  handleAltTextChange: PropTypes.func.isRequired,
  handleFileUpload: PropTypes.func.isRequired,
  handleRemoveUpload: PropTypes.func,
  hasAltTextInput: PropTypes.bool,
  hasIcon: PropTypes.bool,
  hasRemoveUploadButton: PropTypes.bool,
  hasReplaceUploadButton: PropTypes.bool.isRequired,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  isDisabled: PropTypes.bool,
  permittedFormats: PropTypes.string,
  removeUploadButtonText: PropTypes.string,
  replaceUploadButtonText: PropTypes.string,
  upload: PropTypes.shape({
    altText: PropTypes.string,
    file: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    error: PropTypes.string,
    progress: PropTypes.number,
    status: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  uploadButtonText: PropTypes.string.isRequired,
  uploadType: PropTypes.string,
};

export default FormFieldUpload;
